import React from 'react';
import styled from 'styled-components'

const LOGO = styled.div`
@import url('https://fonts.googleapis.com/css2?family=Pacifico&display=swap');

font-family: 'Pacifico', cursive;

 color: white;

 letter-spacing: length;

 user-select: none;
 `

const Logo = ({ size}) =>  
  
 
        <>
<LOGO id="dashH" style={{fontSize: size}}> Iamwealthy </LOGO>
        </>
      
 
 
export default Logo;